import React from "react";
import styled from "styled-components";
import { BaseLink } from "./BaseLink";
import { Icon } from "./Icon";
import { style } from "./style";
import { focusOutline } from "./utils/focusOutlineStyle";

type Props = {
  path: string;
  title: string;
  callback?: () => void;
};

const Link = styled(BaseLink)`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  color: ${style.colors.grey.dark};

  &:hover {
    color: ${style.colors.grey.primary};
  }

  &:focus {
    color: ${style.colors.grey.dark}; /* color: inherit doesn't work here */
    ${focusOutline()};
  }
`;

const BackArrow = styled(Icon)`
  margin-right: ${style.vars.space["3"]};
`;

export const BreadcrumbBack: React.FC<Props> = ({ path, title, callback }) => {
  return (
    <Link to={path} onClick={callback}>
      <BackArrow icon="arrow-left-long" />
      <span>{title}</span>
    </Link>
  );
};
